export const comments_3294072 = {"data":{"data":[],"links":{}}}